import { createFileRoute, redirect } from '@tanstack/react-router';

import { ensureMediaByIdQueryData } from '@/api/media';
import { ImagesBreadcrumb } from '@/features/estates/components/imagesBreadcrumb';

export const Route = createFileRoute(
  '/_authenticated/_sidebar-layout/estates/$estateId/_dashboard-layout/media/edit/$mediaId/'
)({
  loader: async (props) => {
    try {
      return await ensureMediaByIdQueryData(props);
    } catch {
      throw redirect({
        to: '/projects/$projectId/media',
        params: { projectId: props.params.projectId },
      });
    }
  },
  staticData: {
    breadcrumb: () => <ImagesBreadcrumb labels={['Image Editor']} />,
  },
});
